import { render, staticRenderFns } from "./Interfaz.vue?vue&type=template&id=7e2d1563"
import script from "./Interfaz.vue?vue&type=script&lang=js"
export * from "./Interfaz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports